import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const ExclamationTriangle = ({
  className
}) => /*#__PURE__*/React.createElement(FontAwesomeIcon, {
  className: className,
  icon: faExclamationTriangle
});

ExclamationTriangle.propTypes = {
  className: PropTypes.string
};
export default styled(ExclamationTriangle)`
  font-size: 19px;
  color: #ec4a41;
  margin-right: 10px;
`;